import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function QuickBuyPaymentSuccess() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const amount = searchParams.get('amount');
  const currency = searchParams.get('currency');
  const txHash = searchParams.get('tx');
 

  const handleRegisterClick = () => {
    navigate('/token/signup'); 
  };

  const handleCloseNotification = () => {
  navigate('/token/quick-buy');
  };

  useEffect(() => {
    // You might want to verify the payment with your backend here
  }, []);

   const getExplorerUrl = (txHash, chain) => {
    if (chain === 'SOL') {
      return `https://solscan.io/tx/${txHash}`;
    } else {
      return `https://etherscan.io/tx/${txHash}`;
    }
  };


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
      padding: '20px',
      fontFamily: '"Inter", sans-serif'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '40px 30px',
        width: '100%',
        maxWidth: '450px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        textAlign: 'center'
      }}>
        {/* Checkmark icon */}
        <div style={{
          marginBottom: '30px',
          color: '#00ff9d'
        }}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#00ff9d" strokeWidth="2"/>
            <path d="M8 12L11 15L16 9" stroke="#00ff9d" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        
        {/* Success message */}
        <h1 style={{
          color: '#fff',
          fontSize: '28px',
          fontWeight: '700',
          marginBottom: '10px'
        }}>Payment Successful!</h1>
        
        <p style={{
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '16px',
          marginBottom: '30px'
        }}>Your transaction has been completed successfully</p>

       {amount && (
       <>
        {/* Payment details */}
        <div style={{
          background: 'rgba(0, 255, 157, 0.1)',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '30px',
          border: '1px solid rgba(0, 255, 157, 0.2)'
        }}>
  
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px'
          }}>
         
            <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Amount:</span>
            <span style={{ color: '#fff', fontWeight: '600' }}>{amount} {currency}</span>
         
          </div>
                  
          {/* {txHash && (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>TX Hash:</span>
              <a 
                href={`https://etherscan.io/tx/${txHash}`} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  color: '#00ff9d',
                  textDecoration: 'none',
                  fontSize: '14px',
                  maxWidth: '150px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'inline-block'
                }}
              >
                {txHash.slice(0, 6)}...{txHash.slice(-4)}
              </a>
            </div>
          )} */}
           {txHash && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>TX Hash:</span>
                  <a 
                    href={getExplorerUrl(txHash, currency)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      color: '#00ff9d',
                      textDecoration: 'none',
                      fontSize: '14px',
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'inline-block'
                    }}
                  >
                    {txHash.slice(0, 6)}...{txHash.slice(-4)}
                  </a>
                </div>
              )}
         
        </div>
              </>
          )}
        

          <div style={{ marginTop: '20px' }}>
            <h3 style={{ color: '#fff', marginBottom: '15px' }}>Unlock Staking Features</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '20px' }}>
              Create an account to stake your RZTO tokens and earn rewards in your dashboard
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button 
                style={{
                  background: 'linear-gradient(90deg, #00ff9d 0%, #00b8ba 100%)',
                  color: '#000',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '12px 20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  flex: 1,
                  transition: 'all 0.3s ease'
                }}
                onClick={handleRegisterClick}
              >
                Register Now
              </button>
              <button 
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: '#fff',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '12px',
                  padding: '12px 20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  flex: 1,
                  transition: 'all 0.3s ease'
                }}
                onClick={handleCloseNotification}
              >
                Maybe Later
              </button>
            </div>
          </div>
      
    </div>
        </div>

  );
}